import React from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import PersonIcon from "@material-ui/icons/Person";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "0 8px 0 0",
        flex: 1,
        minWidth: 0,
        cursor: "pointer",
        height: "100%",
    },
    avatar: {
        width: 44,
        height: 44,
        border: `2px solid ${theme.mode === "light" ? "rgba(37,99,235,0.22)" : "rgba(96,165,250,0.35)"}`,
        boxShadow: theme.mode === "light"
            ? "0 3px 8px rgba(15,23,42,0.12)"
            : "0 3px 8px rgba(0,0,0,0.35)",
        flexShrink: 0,
    },
    infoBlock: {
        flex: 1,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 3,
    },
    nameLine: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        minWidth: 0,
    },
    name: {
        fontWeight: 700,
        fontSize: "0.94rem",
        color: theme.mode === "light" ? "#0f172a" : "#f8fafc",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        letterSpacing: "0.01em",
    },
    ticketIdBadge: {
        fontWeight: 600,
        fontSize: "0.64rem",
        color: theme.mode === "light" ? "#64748b" : "#94a3b8",
        backgroundColor: theme.mode === "light" ? "rgba(241,245,249,0.95)" : "rgba(30,41,59,0.85)",
        border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.32)" : "rgba(148,163,184,0.38)"}`,
        borderRadius: 6,
        padding: "1px 6px",
        whiteSpace: "nowrap",
        flexShrink: 0,
    },
    subLine: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        flexWrap: "wrap",
    },
    waBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        fontSize: "0.62rem",
        fontWeight: 600,
        color: "#16a34a",
        backgroundColor: "rgba(22,163,74,0.1)",
        borderRadius: 6,
        padding: "1px 7px",
        border: "1px solid rgba(22,163,74,0.22)",
        whiteSpace: "nowrap",
        maxWidth: 160,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    waIcon: {
        fontSize: "0.72rem",
        flexShrink: 0,
    },
    assignedBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        fontSize: "0.62rem",
        fontWeight: 600,
        color: theme.mode === "light" ? "#475569" : "#94a3b8",
        backgroundColor: theme.mode === "light" ? "rgba(241,245,249,0.95)" : "rgba(30,41,59,0.85)",
        borderRadius: 6,
        padding: "1px 7px",
        border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.3)" : "rgba(148,163,184,0.35)"}`,
        whiteSpace: "nowrap",
        maxWidth: 140,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    personIcon: {
        fontSize: "0.72rem",
        flexShrink: 0,
    },
    searchBtn: {
        color: theme.mode === "light" ? "#64748b" : "#94a3b8",
        padding: 6,
        flexShrink: 0,
        "&:hover": {
            color: theme.mode === "light" ? "#2563eb" : "#60a5fa",
            backgroundColor: theme.mode === "light" ? "rgba(37,99,235,0.08)" : "rgba(96,165,250,0.12)",
        },
    },
}));

const TicketInfo = ({ contact, ticket, onClick, onToggleSearch, isSearching }) => {
    const classes = useStyles();

    return (
        <div className={classes.root} onClick={onClick}>
            <Avatar
                src={contact?.urlPicture}
                alt={contact?.name}
                className={classes.avatar}
            />
            <div className={classes.infoBlock}>
                <div className={classes.nameLine}>
                    <span className={classes.name}>
                        {contact?.name || "(sem contato)"}
                    </span>
                    <span className={classes.ticketIdBadge}>#{ticket.id}</span>
                </div>
                <div className={classes.subLine}>
                    {ticket.whatsapp && (
                        <span className={classes.waBadge}>
                            <WhatsAppIcon className={classes.waIcon} />
                            {ticket.whatsapp.name}
                        </span>
                    )}
                    {ticket.user && (
                        <span className={classes.assignedBadge}>
                            <PersonIcon className={classes.personIcon} />
                            {ticket.user.name}
                        </span>
                    )}
                </div>
            </div>
            <Tooltip title={isSearching ? "Fechar busca" : "Buscar na conversa"}>
                <IconButton
                    size="small"
                    className={classes.searchBtn}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (onToggleSearch) onToggleSearch();
                    }}
                >
                    {isSearching ? <CloseIcon fontSize="small" /> : <SearchIcon fontSize="small" />}
                </IconButton>
            </Tooltip>
        </div>
    );
};

export default TicketInfo;
